import { forwardRef, useId } from 'react'
import { cn } from './cn'

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
	label?: React.ReactNode
	size?: 'xs' | 'sm' | 'md'
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
	{ label, size = 'md', className, id, ...rest },
	ref,
) {
	const generatedId = useId()
	const checkboxId = id ?? generatedId
	const control = (
		<input
			ref={ref}
			id={checkboxId}
			type="checkbox"
			className={cn(
				'checkbox-refined',
				size === 'sm' && 'checkbox-refined-sm',
				size === 'xs' && 'checkbox-refined-xs',
				className,
			)}
			{...rest}
		/>
	)
	if (!label) return control
	return (
		<label htmlFor={checkboxId} className="inline-flex items-center gap-2 cursor-pointer text-sm">
			{control}
			<span>{label}</span>
		</label>
	)
})
